import angular from 'angular';

let dependenciesModule = angular.module('app.dependencies',[
  'angular-jwt',
  'ui.router',
  'ui.bootstrap',
  'ngAria',
  'ngMessages',
  'ngCookies',
  'ngAnimate',
  'ngMaterial',
  'rzModule',
  'vcRecaptcha',
  'uiGmapgoogle-maps',
  'simplePagination',
  'ngTable',
  'naif.base64',
  'MassAutoComplete',
  'angularUtils.directives.dirPagination',
  'ui.grid',
  'ui.grid.selection',
  'ui.grid.resizeColumns',
  'ui.grid.edit',
  'ui.grid.rowEdit',
  'ui.grid.cellNav',
  'ui.grid.pinning',
  'ui.grid.pagination',
  'ui.grid.grouping',
  'ui.grid.autoResize',
  'ui.grid.exporter',
  'oc.lazyLoad']);

export default dependenciesModule;



/** WEBPACK FOOTER **
 ** C:/xampp/htdocs/payomaro-pay-zone/www/components/app.dependencies.js
 **/